
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Colmar dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Colmar certifiée Google Partner, accompagne les entreprises colmariennes pour développer leur visibilité en ligne et capter plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Colmar dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Colmar certifiée Google Partner, accompagne les entreprises colmariennes pour développer leur visibilité en ligne et capter plus de prospects.",
        },
      ],
    };
  },
};
